enum ReportingTimeBucket {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
}

export default ReportingTimeBucket;
